import { commonService } from "../../utils/commonService";
import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import callstart from "../../Assets/Images/callstart.svg";
import callend from "../../Assets/Images/callend.svg";


const VoiceBot = ({ initialX, initialY }) => {
    const [position, setPosition] = useState({ x: initialX, y: initialY });

    const [callStart, setcallStart] = useState("NotRunning");

    const StartCall = async () => {
        if (window.SuperMiaVoice?.endCall) {
            await window.SuperMiaVoice.endCall();
        }

        window.botCode = "RCCTTL";

        if (window.SuperMiaVoice?.init) {
            await window.SuperMiaVoice.init();
            if (window.SuperMiaVoice?.proceedWithCall) {
                await window.SuperMiaVoice.proceedWithCall();
                setcallStart("Running");
            }
        }
    }

    const EndCall = async () => {
        if (window.SuperMiaVoice?.endCall) {
            await window.SuperMiaVoice.endCall();
            setcallStart("NotRunning")
        }
    }


    return (
        <>
            {
                callStart === "NotRunning" ?
                    <div id={commonService.generateGlobalClickTrackerID("VoiceBot", "start-call", "")}
                        title="Start Call"
                        onClick={(e) => StartCall()}
                        style={{
                            left: `${position.x}`,
                            bottom: `${position.y}`,

                        }}
                        className="common-call-bot"
                    >
                        <img src={callstart} alt="Start Call" style={{ marginTop: "2px", marginLeft: "-1px" }} />

                    </div >
                    :
                    <div id={commonService.generateGlobalClickTrackerID("VoiceBot", "end-call", "")}
                        title="End Call"
                        onClick={(e) => EndCall()}
                        style={{
                            left: `${position.x}`,
                            bottom: `${position.y}`,

                        }}
                        className="common-call-bot"
                    >
                        <img src={callend} alt="End Call" /> : <img src={callend} alt="End Call" />

                    </div >

            }
        </>

    );
};

export default VoiceBot;
